import { createFileRoute, redirect } from "@tanstack/react-router";
import { FuelCardProductsClient } from "@/features/purchaseInvoices/FuelCardProductsClient";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// BP-producten: which ledger account a product on a BP invoice is booked on (docs/inkoopfacturen.md §17).
export const Route = createFileRoute(
  "/_shell/purchase-invoices/fuel-card-products",
)({
  beforeLoad: ({ context }) => {
    const { session } = context;
    if (
      !session.roles.includes("admin") &&
      !hasModule(session, "purchase_invoices") &&
      !hasModule(session, "purchase_invoices_write")
    ) {
      throw redirect({ to: firstAllowedRoute(session) });
    }
  },
  component: FuelCardProductsScreen,
});

function FuelCardProductsScreen() {
  const { session } = Route.useRouteContext();
  const canWrite =
    session.roles.includes("admin") ||
    hasModule(session, "purchase_invoices_write");
  return (
    <div className="wl-page" data-screen-label="Back-office Fuel Card Products">
      <FuelCardProductsClient canWrite={canWrite} />
    </div>
  );
}
